import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

var ButtonToggle = createReactClass({
  getDefaultProps: () => ({
    value: 0,
    options: []
  }),
  getInitialState: () => ({
    selectedValue: null,
  }),
  componentDidMount() {
    if(this.props.value !== undefined) {
      this.setState({selectedValue: this.props.options[this.props.value]});
    }
  },
  getButtonClassName(value) {
    const btnType = this.state.selectedValue === value ? 'btn-primary' : 'btn-default';
    return `btn ${btnType}`;
  },
  select(value) {
    this.props.onSelect(this.props.options.indexOf(value));
    return this.setState({selectedValue: value});
  },
  render() {
    const buttons = this.props.options.map((value, idx) => {
      return (<button key={idx} type="button" className={this.getButtonClassName(value)} onClick={() => this.select(value)}>{value}</button>)
    });
    return (
      <div className="btn-group" role="group">
        {buttons}
      </div>
    )
  }
});

ButtonToggle.propTypes = {
  value: PropTypes.number,
  options: PropTypes.array.isRequired,
  onSelect: PropTypes.func
};

export default ButtonToggle;



// WEBPACK FOOTER //
// ./src/components/common/Forms/ButtonToggle.js